import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

export default class ContractTypeSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (type) => {
        this.props.handleChange(type);
    }

    render() {
        const types = [
            { value: 'WITH_RETENTION', label: 'Contrato con Retención' },
            { value: 'WITH_BILLING', label: 'Contrato con Facturación' }
        ];
        return (
            <OgaSelect
                bsSize="small"
                placeholder="Seleccione Tipo de Contrato"
                disabled={this.props.disabled}
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={types}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ContractTypeSelect/ContractTypeSelect.jsx